export const tableColumnsSize = {
  dragBtn: 40,
  rate: 110,
  discount: 68,
  cost: 110
}

export const rateColStyles = {
  minWidth: tableColumnsSize.rate,
  maxWidth: tableColumnsSize.rate,
  justifyContent: 'flex-end'
}

export const reachColStyles = { minWidth: 70, maxWidth: 70, justifyContent: 'flex-end' }

export const assetColStyles = { minWidth: 215, whiteSpace: 'normal' }

export const assetTypeColStyles = { minWidth: 150, maxWidth: 150, whiteSpace: 'normal' }

export const getCategoryColStyles = hasReachData => ({
  minWidth: hasReachData ? 118 : 125,
  maxWidth: hasReachData ? 118 : 125,
  whiteSpace: 'normal'
})
export const getRegionColStyles = hasReachData => ({
  minWidth: hasReachData ? 116 : 120,
  maxWidth: hasReachData ? 116 : 120,
  whiteSpace: 'normal'
})

export const locationColStyles = { minWidth: 140, maxWidth: 140, whiteSpace: 'normal' }
